This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="homePage">
    <!-- Selling point playful learning -->
    <div class="sellingpoint left grid lg:grid-cols-2 md:grid-cols-1">
      <div class="sellText">
        <h1>{{ $t("home.learningTitle") }}</h1>
        <div class="bigStripe"></div>
        <div class="smallStripe"></div>
        <h2>{{ $t("home.learningText") }}</h2>
      </div>
      <div class="sellImage">
        <img src="@/assets/images/home/PSD.png" alt="PSD image" />
      </div>
    </div>
    <!-- Selling point extra challenge -->
    <div class="sellingpoint right grid lg:grid-cols-2 md:grid-cols-1">
      <div class="sellImage bigScreen">
        <img src="@/assets/images/home/Script.png" alt="Script image" />
      </div>
      <div class="sellText">
        <h1>{{ $t("home.challengeTitle") }}</h1>
        <div class="bigStripe"></div>
        <div class="smallStripe"></div>
        <h2>{{ $t("home.challengeText") }}</h2>
      </div>
      <div class="sellImage smallScreen">
        <img src="@/assets/images/home/Script.png" alt="Script image" />
      </div>
    </div>
    <!-- Selling point interactive -->
    <div class="sellingpoint left grid lg:grid-cols-2 md:grid-cols-1">
      <div class="sellText">
        <h1>{{ $t("home.interactiveTitle") }}</h1>
        <div class="bigStripe"></div>
        <div class="smallStripe"></div>
        <h2>{{ $t("home.interactiveText") }}</h2>
      </div>
      <div class="sellImage">
        <img src="@/assets/images/home/Game.png" alt="Game image" />
      </div>
    </div>
    <!-- Selling point for students, by students -->
    <div class="sellingpoint right grid lg:grid-cols-2 md:grid-cols-1">
      <div class="sellImage bigScreen">
        <img src="@/assets/images/home/Team.png" alt="Team image" />
      </div>
      <div class="sellText">
        <h1>{{ $t("home.makersTitle") }}</h1>
        <div class="bigStripe"></div>
        <div class="smallStripe"></div>
        <h2>{{ $t("home.makersText") }}</h2>
      </div>
      <div class="sellImage smallScreen">
        <img src="@/assets/images/home/Team.png" alt="Team image" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  mounted() {
    //Animate stripes when visible on screen
    const stripes = document.querySelectorAll(".sellText");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add("animationVisible");
        }
      });
    });
    stripes.forEach((stripe) => {
      observer.observe(stripe);
    });
  },
})
export default class Home extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/Home.scss";
</style>
